"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = void 0;
exports.ROUTES = [
    { id: 1, route: "/", title: "Graph" },
    { id: 2, route: "/portfolio", title: "Portfolio" },
];
